import { TargetPreference } from '@streamster/shared/socket/document.type';
import { ManagerPermission } from '@streamster/shared/constants/managerPermissions';
import AdminProfileIcon from '../../assets/icons/account-key.svg';
import ProfileIcon from '@streamster/shared/assets/icons/account.svg';
import StreamIcon from '../../assets/icons/broadcast.svg';
import StatisticsIcon from '../../assets/icons/chart-bar.svg';
import TariffIcon from '../../assets/icons/currency-usd.svg';
import GiftIcon from '../../assets/icons/gift.svg';
import HomeIcon from '../../assets/icons/home-circle.svg';
import InvoiceIcon from '../../assets/icons/invoice.svg';
import LayersIcon from '../../assets/icons/layers.svg';
import ChatsIcon from '@streamster/shared/assets/icons/message-text.svg';
import SparklingIcon from '../../assets/icons/sparkling.svg';
import TicketPercentIcon from '../../assets/icons/ticket-percent.svg';
import { Route } from './WebNavigation';

export const ROUTES: Route[] = [
  {
    name: 'Home',
    screens: ['Home'],
    href: '/home',
    icon: HomeIcon,
    showForWhiteLabel: false,
  },
  {
    name: 'Admin Profile',
    screens: ['AdminProfile'],
    href: '/admin-profile',
    icon: AdminProfileIcon,
    businessIndent: true,
    hideForBusinessUsers: true,
    admin: true,
  },
  {
    name: 'Live stream',
    screens: ['ActiveStream', 'Stream'],
    href: '/stream',
    icon: StreamIcon,
    activeIfStreaming: true,
    businessIndent: true,
  },
  {
    name: 'Chats',
    screens: ['Chats'],
    icon: ChatsIcon,
    href: '/chats',
    businessIndent: true,
    showForChatsConfigured: true,
    showForTarget: TargetPreference.Adult,
    requirePermission: ManagerPermission.ViewChat,
  },
  {
    name: 'Overlays',
    screens: ['Overlays'],
    href: '/overlays',
    businessIndent: true,
    icon: LayersIcon,
    requirePermission: ManagerPermission.SetupOverlays,
  },
  {
    name: 'Statistics',
    screens: ['Statistics'],
    href: '/statistics',
    icon: StatisticsIcon,
    hideForBusinessUsers: true,
    businessIndent: true,
    requireCompleteProfile: true,
  },
  {
    name: 'Profile',
    screens: ['Profile', 'Billing'],
    href: '/profile',
    icon: ProfileIcon,
    hideForBusinessUsers: true,
    businessIndent: true,
  },
  {
    name: 'Pricing plans',
    screens: ['Tariff'],
    href: '/tariff',
    icon: TariffIcon,
    hideForBusinessUsers: true,
    businessIndent: true,
  },
  // DEPRECATED — the Freshdesk-backed "Support" route was removed here on
  // 2026-07-22. Support now lives in the sy-support-chat widget, which carries
  // its own ticket list. The screens under screens/support/ and the account
  // backend's /me/tickets endpoints are kept until the Freshdesk teardown —
  // see streamster-account/docs/freshdesk-removal.md.
  {
    name: 'Billing',
    screens: ['AdminBilling'],
    href: '/admin-billing',
    icon: InvoiceIcon,
    admin: true,
    ifConfig: 'billingEnabled',
  },
  {
    name: 'Coupons',
    screens: ['AdminCouponCodes'],
    href: '/coupon-codes',
    icon: TicketPercentIcon,
    admin: true,
  },
  {
    name: 'Refer a friend',
    screens: ['ReferAFriend'],
    href: '/refer-a-friend',
    icon: GiftIcon,
    hideForBusinessUsers: true,
    hideForBusiness: false,
    hideForAdmin: true,
    requireCompleteProfile: true,
  },
  {
    name: 'CamGems',
    screens: [],
    href: 'https://camgems.com/',
    icon: SparklingIcon,
    showForTarget: TargetPreference.Adult,
    showForWhiteLabel: false,
    hideForAdmin: true,
  },
];
